var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"py-3 pl-5 md:pl-20 font-semibold text-base text-gray-900 bg-white"},[_vm._v(" © 2022 Shoot! "+_vm._s(_vm.$t("rights"))+". ")])}
var staticRenderFns = []

export { render, staticRenderFns }